import { userService, authService, ecoSettingService, restClient } from "client-app-core";
import { openDialog } from "orion-components/AppState/Actions";
import { logOut } from "../Identity/actions";
import * as t from "./actionTypes";

/*
 * Set a user's profile in state
 * @param user: user object
 */
const hydrateUserSuccess = res => {
	return {
		type: t.HYDRATE_USER_SUCCESS,
		user: res.user,
		org: res.org,
		externalSystems: res.externalSystems
	};
};

const refreshUserSuccess = profile => {
	return {
		type: t.REFRESH_USER_SUCCESS,
		user: profile
	};
};

const logoutPrevented = res => {
	return {
		type: t.LOGOUT_PREVENTED,
		failedLogoutCondition: res
	};
};

const endSession = () => {
	return {
		type: t.SESSION_ENDED
	};
};

const handleSessionEnd = mockStore => {
	mockStore.dispatch(endSession());
};

const firstUseTextReceived = text => {
	return {
		type: t.FIRST_USE_TEXT_RECEIVED,
		payload: { text }
	};
};

export const getFirstUseText = () => {
	return dispatch => {
		ecoSettingService.getByKey("clientConfig", (err, response) => {
			if (err) console.log("ERROR", err);
			if (!response) return;
			const { firstUseText } = response;
			if (firstUseText) dispatch(firstUseTextReceived(firstUseText));
		});
	};
};

const firstUseConfirmed = () => {
	return {
		type: t.FIRST_USE_CONFIRMED
	};
};

export const confirmFirstUse = userId => {
	return dispatch => {
		const update = { firstUseAck: true };
		userService.updateUser(userId, update, (err, response) => {
			if (err) console.log("ERROR", err);
			if (!response) return;
			dispatch(firstUseConfirmed());
		});
	};
};

/*
 * Get a user's profile
 * @param userId: user's ID
 */
export const hydrateUser = userId => {
	return dispatch => {
		return new Promise(resolve => {
			userService.getProfile(userId, (err, response) => {
				if (err) {
					console.log(err);
					if (err.response.status === 404 || err.response.status === 401) {
						dispatch(logOut());
					}
				} else {
					const { firstUseAck } = response.user;
					dispatch(hydrateUserSuccess(response));
					const mockStore = { dispatch };
					const handler = handleSessionEnd.bind(this, mockStore);
					authService.addSessionEndHandler(handler);
					if (!firstUseAck) dispatch(getFirstUseText());
					resolve();
				}
			});
		});
	};
};

/*
 * Set a user's profile - used in portable replay
 * @param userProfile: user profile with same schema retrieved in hydrateUser
 */
export const setUserProfile = userProfile => {
	return dispatch => {
		dispatch(hydrateUserSuccess(userProfile));
	};
};

/*
 * Check if user is allowed to log out with given conditions.
 * If allowed, proceeds to call logout function, otherwise opens a dialog.
 */
export const checkLogout = () => {
	return dispatch => {
		authService.checkLogout((err, response) => {
			if (err) {
				console.log(err);
			}
			const { canLogout, failedLogoutCondition } = response;
			if (canLogout) {
				dispatch(manualLogout());
			} else {
				dispatch(logoutPrevented(failedLogoutCondition));
				dispatch(openDialog("logoutPrevention"));
			}
		});
	};
};

export const manualLogout = () => {
	return dispatch => {
		dispatch(logOut());
		dispatch({
			type: t.MANUAL_LOGOUT
		});
	};
};

export const updateLabels = (newAppLabels = [], newIntLabels = []) => {
	return (dispatch, getState) => {
		const { profile } = getState().session.user;
		const { applications, integrations } = profile;

		const appLabels = applications.map(app => {
			const newLabel = newAppLabels.find(label => label.appId === app.appId);
			return newLabel ? { ...app, ...newLabel } : app;
		});
		const intLabels = integrations.map(int => {
			const newLabel = newIntLabels.find(label => label.intId === int.intId);
			return newLabel ? { ...int, ...newLabel } : int;
		});
		const userProfile = { ...profile, applications: appLabels, integrations: intLabels };
		dispatch(refreshUserSuccess(userProfile));
	};
};
